import React, { useContext, useEffect } from 'react'
import { navigate } from 'gatsby'
import ContentProfile from '../components/organisms/content-profile/content-profile'
import PageLayout from '../components/templates/page-layout/page-layout'
import { Context } from '../context/app-context'
import userSessionStorage from '../utils/userSessionStorage'

const Perfil = () => {
  const { dispatch } = useContext(Context)
  const session = new userSessionStorage()

  useEffect(() => {
    // const tokenInfo = session.getToken()
    const userInfo = session.getUserInfo()
    if (!userInfo) {
      dispatch({
        type: 'set-modal',
        modalActive: {
          type: 'login',
          props: {
            close: () => {
              dispatch({ type: 'clear-modal' })
              navigate('/')
            },
            handleSuccess: () => {
              window.location.reload()
            },
            // mobile: isMobile,
          },
        },
      })
    }
  }, [])

  return (
    <PageLayout>
      <ContentProfile />
    </PageLayout>
  )
}
export default Perfil
